import type { Property, Amenity, GalleryImage, Location } from '../types';

// Main property data for Rizes Sifnos
export const mockProperty: Property = {
  property_id: 'rizes_sifnos_01',
  name: 'Rizes - Island Summer House',
  base_price_low: 120,
  base_price_mid: 180,
  base_price_high: 250,
  surge_threshold: 0.85,
  photos_json: [
    '/photos/exterior_1.jpg',
    '/photos/living_room_1.jpg',
    '/photos/kitchen_1.jpg',
    '/photos/dining_1.jpg',
    '/photos/bedroom 1_1.jpg',
    '/photos/bedroom 2_1.jpg',
    '/photos/full bathroom_1.jpg',
    '/photos/exterior_2.jpg',
  ],
  description: 'A quiet house in Rizes, Sifnos. Two bedrooms, close to Apollonia.',
  amenities: [
    '2 Bedrooms',
    'Sea View',
    'Fast Wi-Fi',
    'Air Conditioning',
  ],
  location: {
    address: 'Rizes, Sifnos, Cyclades, Greece',
    lat: 36.969243,
    lng: 24.714247,
  },
};

// Mock amenities with icons
export const mockAmenities: Amenity[] = [
  { id: 'bedrooms', name: '2 Bedrooms', icon: 'bed', description: 'Comfortable sleeping arrangements' },
  { id: 'sea-view', name: 'Sea View', icon: 'eye', description: 'Stunning views of the Aegean Sea' },
  { id: 'wifi', name: 'Fast Wi-Fi', icon: 'wifi', description: 'High-speed internet access' },
  { id: 'ac', name: 'Air Conditioning', icon: 'snowflake', description: 'Stay cool during summer' },
];

// Mock gallery images - using actual photos from rizes_photos
export const mockGalleryImages: GalleryImage[] = [
  { 
    id: '1', 
    url: '/photos/exterior_1.jpg', 
    thumbnail: '/photos/exterior_1.jpg', 
    heroUrl: '/photos/hero/exterior_1.jpg',
    alt: 'Exterior View', 
    order: 1 
  },
  { 
    id: '2', 
    url: '/photos/living_room_1.jpg', 
    thumbnail: '/photos/living_room_1.jpg', 
    heroUrl: '/photos/hero/living_room_1.jpg',
    alt: 'Living Room', 
    order: 2 
  },
  { 
    id: '3', 
    url: '/photos/living_room_2.jpg', 
    thumbnail: '/photos/living_room_2.jpg', 
    heroUrl: '/photos/hero/living_room_2.jpg',
    alt: 'Living Room View 2', 
    order: 3 
  },
  { 
    id: '4', 
    url: '/photos/kitchen_1.jpg', 
    thumbnail: '/photos/kitchen_1.jpg', 
    heroUrl: '/photos/hero/kitchen_1.jpg',
    alt: 'Full Kitchen', 
    order: 4 
  },
  { 
    id: '5', 
    url: '/photos/kitchen_2.jpg', 
    thumbnail: '/photos/kitchen_2.jpg', 
    heroUrl: '/photos/hero/kitchen_2.jpg',
    alt: 'Kitchen View 2', 
    order: 5 
  },
  { 
    id: '6', 
    url: '/photos/dining_1.jpg', 
    thumbnail: '/photos/dining_1.jpg', 
    alt: 'Dining Area', 
    order: 6 
  },
  { 
    id: '7', 
    url: '/photos/bedroom 1_1.jpg', 
    thumbnail: '/photos/bedroom 1_1.jpg', 
    alt: 'Bedroom 1', 
    order: 7 
  },
  { 
    id: '8', 
    url: '/photos/bedroom 1_2.jpg', 
    thumbnail: '/photos/bedroom 1_2.jpg', 
    alt: 'Bedroom 1 View 2', 
    order: 8 
  },
  { 
    id: '9', 
    url: '/photos/bedroom 2_1.jpg', 
    thumbnail: '/photos/bedroom 2_1.jpg', 
    alt: 'Bedroom 2', 
    order: 9 
  },
  { 
    id: '10', 
    url: '/photos/full bathroom_1.jpg', 
    thumbnail: '/photos/full bathroom_1.jpg', 
    alt: 'Full Bathroom', 
    order: 10 
  },
  { 
    id: '11', 
    url: '/photos/exterior_2.jpg', 
    thumbnail: '/photos/exterior_2.jpg', 
    alt: 'Exterior View 2', 
    order: 11 
  },
  { 
    id: '12', 
    url: '/photos/exterior_3.jpg', 
    thumbnail: '/photos/exterior_3.jpg', 
    alt: 'Exterior View 3', 
    order: 12 
  },
];

// Mock location - Rizes Sifnos
export const mockLocation: Location = {
  address: 'Rizes, Sifnos, Cyclades, Greece',
  lat: 36.969243,
  lng: 24.714247,
  city: 'Sifnos',
  region: 'Cyclades, Greece',
};

// Mock unavailable dates (for demonstration)
export const mockUnavailableDates: string[] = [
  '2024-10-15',
  '2024-10-16',
  '2024-10-17',
  '2024-10-20',
  '2024-10-21',
];
